import React, { useState } from 'react';
import {
  loadUsersModifiedByWeekByUser,
  exportUsersModifiedByWeekByUser,
} from '../../../../actions/reportByWeekActions';
import { Table, SimpleTextFilter, TableColumn, getVisibleColumns } from '../../../common/Table';
import { CommaNumber_NoDecimal } from '../../../../util/formatter';
import Loading from '../../../common/Loading';
import KwPanel from '../../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../../hooks/useTableSettings';
import { useReportYear } from '../../../../hooks/useReportYear';
import YearFormSelect from '../YearFormSelect';
import UserLink from '../../../common/links/UserLink';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export interface UsersModifiedByWeekByUserListProps { tableViewSwitcher?: React.ReactNode }
function UsersModifiedByWeekByUserList({ tableViewSwitcher }: UsersModifiedByWeekByUserListProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const { year, years, makeHandleYearChange } = useReportYear();
  const [reload, setReload] = useState<Date | undefined>();
  const allColumns = ['fullName', 'year'];
  for (let i = 1; i <= 52; i++) {
    allColumns.push(`week${i}`);
  }
  const defaultVisibleColumns = allColumns;
  const [items, setItems] = useState<any>();
  const params = new URLSearchParams(location.search);
  const {
    tableSettings,
    handleSetTableSettings: setTableSettings,
    filters,
    filterChange,
    isLoading,
    parameters,
  } = useTableSettings(
    'usersmodifiedbyweekbyuserlist-settings',
    getTableSettingsDefaults({
      defaultSort: 'fullName',
      defaultVisibleColumns,
    }),
    { year },
    loadUsersModifiedByWeekByUser,
    setItems,
    reload,
    t('Failed to load report')
  );

  let columnsConfig: TableColumn[] = [
    {
      Key: 'fullName',
      Label: t('Uploading user'),
      Render: (item: any) => (
        <UserLink id={item.userProfileId} name={item.fullName} imageSize={32} />
      ),
      Filter: {
        Render: (col: any) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value: string) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'year',
      Label: t('Year'),
      Render: (item: any) => item.year,
    },
  ];
  for (let i = 1; i <= 52; i++) {
    columnsConfig.push({
      Key: `week${i}`,
      Label: i.toString(),
      Render: (row: any) => CommaNumber_NoDecimal(row[`week${i}`]),
    });
  }

  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);
  const handleYearChange = makeHandleYearChange(parameters, setReload);

  return items ? (
    <>
      <div className="form-horizontal row px-4 px-md-0">
        <div className="col-md-6">
          <YearFormSelect
            year={year}
            years={years}
            handleYearChange={handleYearChange}
          />
        </div>
      </div>
      <KwPanel className="mb-4">
        <Table
          className="table-v-stripes"
          columns={columns}
          allColumns={allColumns}
          rows={items.data.map((x: any) => ({ Key: x.uploadinguserId, ...x }))}
          totalRowCount={items.totalRowCount}
          filteredRowCount={items.filteredRowCount}
          tableSettings={tableSettings}
          setTableSettings={setTableSettings}
          isLoading={isLoading}
          filters={filters}
          filterChange={filterChange}
          exportData={(filters: any, scopes: any) =>
            exportUsersModifiedByWeekByUser(year, filters, scopes)
          }
          tableActionBarButtons={tableViewSwitcher}
        />
      </KwPanel>
    </>
  ) : (
    <Loading />
  );
}
export default UsersModifiedByWeekByUserList;
